<template>
  <div class="apply-list">
    <div class="list-container">
      <div class="item" v-for="(item, index) in configs" :key="index">
        <div class="header">
          <img :src="item.icon" />
          <span class="name">{{ item.productName }}</span>
          <button class="repay-btn"
                  v-if="item.repaymentJump"
                  @click="apiProductRepayAction(item)"
          >
            去还款
          </button>
          <button :class="['status-btn', { ing: item.displayInfo.applying }]"
                  v-if="item.displayInfo.showWithdrawOrApplyingButton"
                  @click="apiProductWithdraw(item)"
          >
            <span>{{ item.displayInfo.withdrawOrApplyingButtonTitle }}</span>
          </button>
        </div>
        <div class="content">
          <div class="left">
            <div class="price">
              <span>{{ item.displayInfo.amountTitle }}</span>
              <p>{{ item.displayInfo.amount }}</p>
            </div>
            <div class="rate">
              <span>年化利率 </span>
              <p>{{ item.minPrice }}%-{{
                item.maxPrice
              }}%</p>
            </div>
            <div class="time-limit">
              <span>期限</span>
              <p>{{item.minTerms}}-{{item.terms}}个月</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="invalidation" v-if="groupedExpireConfigs.length">失效申请 <i class="icon"></i></div>

    <div class="disable-item" v-for="(section, index) in groupedExpireConfigs" :key="index + 'a'">
      <p class="disable-item-date">{{section.applyDate}} 申请</p>

      <div class="item" v-for="(item, index) in section.items" :key="'expired' + index" @click="jumpMiddle(item)">
        <div class="header">
          <img :src="item.icon" />
          <span class="name">{{ item.productName }}</span>
          <div :class="['status-btn', { disabled: true }]">
            <span>审批未通过</span>
          </div>
        </div>
        <div class="content">
          <div class="left">
            <div class="price">
              <span>额度高达 (元) </span>
              <p>{{ item.configLimit | currency }}</p>
            </div>
            <div class="rate">
              <span>年化利率 </span>
              <p>{{ item.minPrice }}%-{{
                item.maxPrice
              }}%</p>
            </div>
            <div class="time-limit">
              <span>期限</span>
              <p>{{item.minTerms}}-{{item.terms}}个月</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { getKey } from '@/assets/utils'
export default {
  data () {
    return {
      configs: [],
      groupedExpireConfigs: [],
      btnNameMap: {
        'IN_HANDLE': '',
        'SUC': '去借款'
      }
    }
  },
  mounted () {
    this.getApplyListX()
  },
  methods: {
    ...mapActions('user', [
      'getApplyList',
      'getApiProductUrl'
    ]),
    ...mapActions('apiDiversion', ['creditApply']),
    async getApplyListX () {
      const { success, data } = await this.getApplyList()
      if (success) {
        const originalData = data.configs || []
        this.configs = originalData.map((item) => {
          const displayInfo = this.getAmountDisplayInfo(item)
          item.displayInfo = displayInfo
          return item
        })
        this.groupedExpireConfigs = (data.expireConfigs || [])
          .reduce((pre, cur) => {
            const applyDate = this.formatDate(cur.applyTime)
            const sameDateSection = pre.find((item) => item.applyDate === applyDate)
            if (sameDateSection) {
              sameDateSection.items.push(cur)
            } else {
              const item = {
                applyDate,
                items: [cur]
              }
              pre.push(item)
            }
            return pre
          }, [])
        console.log(this.groupedExpireConfigs)
      }
    },
    // 去借款
    borrowMoney (item = {}, index) {
      if (item.displayInfo.applying) { return }
      const token = getKey('userInfo', 'token')
      if (token) {
        this.jumpMiddle(item)
      } else {
        this.$router.push(`/landing/river?configId=${item.configId}`)
      }
    },
    // api产品卡片提现
    apiProductWithdraw (product) {
      if (product.applyStatus === 'IN_HANDLE') {
        this.jumpMiddle(product)
      } else {
        this._getApiProductUrl(product, 'LOAN')
      }
    },
    // api产品卡片还款
    apiProductRepayAction (product) {
      this._getApiProductUrl(product, 'REPAY')
    },
    async _getApiProductUrl (product, type) {
      const { success, data } = await this.getApiProductUrl({
        configId: product.configId,
        unionType: type
      })
      if (success && data.url) {
        window.location.href = data.url
      }
    },
    // 跳转中间界面
    jumpMiddle (item) {
      const { source } = this.$route.query || {}
      let sourceData = source ? { source } : {}
      const { configId, productName, logo, configLimit, needExLogin, autoJump } = item
      this.$router.push({
        path: '/river/middle',
        query: {
          configId,
          productName,
          logo,
          configLimit,
          needExLogin,
          autoJump,
          ...sourceData
        }
      })
    },
    getAmountDisplayInfo (apiProductItem) {
      /*
      applyStatus: 申请状态
      withdrawalJumpUrl: 可提现
      availableAmount: 可用额度
      creditLimit： 授信额度/总额度
      configLimit: 最高额度
      */
      const { applyStatus,
              withdrawalJump,
              availableAmount,
              creditLimit,
              configLimit
      } = apiProductItem || {}
      const applying = applyStatus === 'IN_HANDLE'
      const hasAvailabelAmount = availableAmount !== null
      const amountTitle = applying ? '额度高达（元）' : hasAvailabelAmount ? '可用额度（元）' : '授信额度（元）'
      const amountNumber = applying ? configLimit : hasAvailabelAmount ? availableAmount : creditLimit
      const formattedAmount = this.formatMoney(amountNumber)
      const showWithdrawOrApplyingButton = withdrawalJump || applying
      const withdrawOrApplyingButtonTitle = applying ? '审核中' : '去提现'
      return {
        applying,
        amountTitle,
        amount: formattedAmount,
        showWithdrawOrApplyingButton,
        withdrawOrApplyingButtonTitle
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.apply-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 40px;
  .list-container {
    overflow: hidden;
  }
  .disable-item-date {
    flex: 1;
    text-align: left;
    font-size: 24px;
    color: #999;
    margin-bottom: 10px;
  }
  .item {
    width: 690px;
    background: #ffffff;
    padding: 24px 30px 30px;
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    border-radius: 20px;
    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      img {
          width: 48px;
          height: 48px;
        }
        .name {
          font-size: 28px;
          font-weight: 500;
          margin-left: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          flex: 1;
        }
        .time {
          font-size: 20px;
          flex: 1;
          text-align: right;
        }

      .status-btn {
        width: 170px;
        height: 60px;
        background: linear-gradient(90deg, #ff3333 0%, #ff5f34 100%);
        border: none;
        border-radius: 30px;
        font-size: 28px;
        color: #ffffff;
        line-height: 60px;
        text-align: center;
        margin-left: 20px;
        &.ing {
          opacity: 0.4;
        }
        &.disabled {
          background: #dddddd;
        }
      }

      .repay-btn {
        width: 170px;
        height: 60px;
        background: #fff;
        border-radius: 30px;
        border: 1px solid #DE6969;
        font-size: 28px;
        color: #FF4633;
        line-height: 60px;
        text-align: center;
      }
    }
    .content {
      display: flex;
      margin: 24px 0 0;
      padding-top: 30px;
      border-top: 1px solid #e0e0e0;
      .left {
        flex: 1;
        display: flex;
        justify-content: space-between;

        .price {
          span {
            color: #999;
          }
          p {
            font-size: 40px;
            line-height: 48px;
            font-family: DIN-Medium, DIN;
            font-weight: 500;
          }
        }
        .rate {
          span {
            color: #999;
          }
          p {
            font-size: 24px;
            line-height: 48px;
          }
        }
        .time-limit {
          span {
            color: #999;
          }
          p {
            color: #333
          }
        }
      }
    }
  }
  .invalidation {
    font-size: 28px;
    text-align: center;
    font-weight: 500;
    color: #999;
    margin: 30px 0;
    display: flex;
    align-items: center;
    .icon {
      width: 32px;
      height: 32px;
      background: url(../images/icon_jiantou.png) no-repeat center center;
      background-size: contain;
      margin-left: 10px;
    }
  }
}
</style>
